<div class="important-alert-popup" *ngIf="alert">
  <div class="alert-header">
    <mat-icon class="alert-icon">info</mat-icon>
    <h3 class="alert-title">{{ alert.title }}</h3>
  </div>

  <div class="alert-content">
    <div [innerHTML]="alert.message" class="alert-message"></div>
  </div>
</div>
